export default {
    pay: "Pay",
    cancelPayment: "Cancel Payment",
    requirePopupsWarning: "Please note that the selected payment method might require popups to be allowed in your browser settings for optimal functionality. Alternatively, for the best user experience on mobile devices, we recommend using the Bookli app."
}